import Label from '../../../../components/label/label';
import Input from '../../../../components/input/input';
import Button from '../../../../components/button/button';
import IconFA from '../../../../components/icon/icon';
import { useEffect, useState } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import { useAlert } from '../../../../hooks/useAlert';

function CreatePositions({ onInvoiceChange, handleCreateInvoice }) {
    const [items, setItems] = useState([]);
    const [item, setItem] = useState('');
    const [tax, setTax] = useState(0);
    const [price, setPrice] = useState('');
    const [count, setCount] = useState('');
    const { showAlert } = useAlert();

    useEffect(() => {
        onInvoiceChange({ items });
    }, [items, onInvoiceChange]);

    const handleAdd = () => {
        if (!item || !price || !count) {
            showAlert('Bitte fülle alle Felder aus.', 'error');
            return;
        }
        const netPrice = parseFloat(price) || 0;
        const quantity = parseInt(count) || 0;
        const totalNet = netPrice * quantity;
        const totalBrut = totalNet * (1 + (parseFloat(tax) || 0) / 100);

        const newItem = {
            position: items.length + 1,
            item,
            price: netPrice.toFixed(2),
            count: quantity,
            totalNet: totalNet.toFixed(2),
            totalBrut: totalBrut.toFixed(2)
        };

        setItems([...items, newItem]);
        setItem('');
        setPrice('');
        setCount('');
    };

    const sumNet = items.reduce((sum, item) => sum + parseFloat(item.totalNet), 0);
    const sumBrut = items.reduce((sum, item) => sum + parseFloat(item.totalBrut), 0);

    return (
        <div className='createPositionContainer'>
            <h2>Leistungspositionen hinzufügen</h2>
            <div style={{ width: '100%', display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                <div className='createPosInputContainer'>
                    <Label labelFor='item' labelValue='Leistung/ Beschreibung: ' />
                    <textarea
                        id='item'
                        name='item'
                        style={{ width: 'clamp(100px, 100%, 300px)', height: '80px', borderColor: 'black', padding: '8px', borderRadius: '4px', fontSize: '14px' }}
                        placeholder='Leistung beschreiben...'
                        value={item}
                        onChange={(e) => setItem(e.target.value)}
                    />
                </div>
                <div className='createPosInputContainer'>
                    <Label labelFor='count' labelValue='Anzahl: ' />
                    <Input inputId='count' inputName='count' inputType='number' width='100px' borderColor='black' inputValue={count} onChange={(e) => setCount(e.target.value)} />
                </div>
                <div className='createPosInputContainer'>
                    <Label labelFor='price' labelValue='Einzelpreis: ' />
                    <Input inputId='price' inputName='price' inputType='number' width='100px' borderColor='black' inputValue={price} onChange={(e) => setPrice(e.target.value)} />
                </div>
            </div>

            <Button className='createButton' onClick={handleAdd} buttonValue='Hinzufügen' />

            <table className='createTable'>
                <thead>
                    <tr>
                        <th className='createTh'>Pos.</th>
                        <th className='createTh'>Leistung</th>
                        <th className='createTh'>Einzelpreis<br />(Net.)</th>
                        <th className='createTh'>Anzahl</th>
                        <th className='createTh'>Gesamtpreis<br />(Net.)</th>
                        <th className='createTh'>Aktionen</th>
                    </tr>
                </thead>
                <tbody>
                    {items.map((item, index) => (
                        <tr key={index}>
                            <td className='createTd' data-label='Pos.'>{item.position}</td>
                            <td className='createTd' id='createTdMobile'>
                                <span>{item.item}</span>
                                <span>{item.price} € x {item.count} Stück</span>
                                <span><strong>{item.totalNet} €</strong></span>
                            </td>
                            <td className='createTd' data-label='Leistung'>{item.item}</td>
                            <td className='createTd' data-label='Einzelpreis (Net.)'>{item.price} €</td>
                            <td className='createTd' data-label='Anzahl'>{item.count}</td>
                            <td className='createTd' data-label='Gesamt (Net.)'>{item.totalNet} €</td>
                            <td className='createTd' data-label='Aktionen'>
                                <IconFA
                                    iconName='trash'
                                    fontSize='18px'
                                    onClick={() => {
                                        const updatedItems = items.filter((_, i) => i !== index);
                                        setItems(updatedItems);
                                    }}
                                />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <p><strong>Summe Netto:</strong> {sumNet.toFixed(2)} €</p>
            <p><strong>Summe Brutto:</strong> {sumBrut.toFixed(2)} €</p>

            <Button
                className="containerButton"
                onClick={handleCreateInvoice}
                buttonValue="Neue Rechnung erstellen"
            />
        </div>
    );
}

export default CreatePositions;